export const ActionType = {
    USER_LOGIN: 'USER_LOGIN',
    USER_LOGOUT: 'USER_LOGOUT',

    //Login
    RESET_LOADING: 'RESET_LOADING',
    LOGIN_USER_BEGIN: 'LOGIN_USER_BEGIN',
    LOGIN_USER_SUCCESS: 'LOGIN_USER_SUCCESS',
    LOGIN_USER_FAILURE: 'LOGIN_USER_FAILURE',

    //Registration
    REGISTER_USER_BEGIN: 'REGISTER_USER_BEGIN',
    REGISTER_USER_SUCCESS: 'REGISTER_USER_SUCCESS',
    REGISTER_USER_FAILURE: 'REGISTER_USER_FAILURE',
    GET_LOCATION_SUCCESS: 'GET_LOCATION_SUCCESS',

    //Forgot password
    SEND_CODE_BEGIN: 'SEND_CODE_BEGIN',
    SEND_CODE_SUCCESS: 'SEND_CODE_SUCCESS',
    SEND_CODE_FAILURE: 'SEND_CODE_FAILURE',
    RECOVER_PASSWORD_BEGIN: 'RECOVER_PASSWORD_BEGIN',
    RECOVER_PASSWORD_SUCCESS: 'RECOVER_PASSWORD_SUCCESS',
    RECOVER_PASSWORD_FAILURE: 'RECOVER_PASSWORD_FAILURE',
    CHANGE_PASSWORD_BEGIN: 'CHANGE_PASSWORD_BEGIN',
    CHANGE_PASSWORD_SUCCESS: 'CHANGE_PASSWORD_SUCCESS',
    CHANGE_PASSWORD_FAILURE: 'CHANGE_PASSWORD_FAILURE',

    // Sub Afiiliate Id selected from tree
    MAIN_AFFILIATE_ID: 'MAIN_AFFILIATE_ID',
    SUB_AFFILIATE_ID: 'SUB_AFFILIATE_ID',
    SET_SELECTED_TREE_VALUE: 'SET_SELECTED_TREE_VALUE',

    // Affiliate type
    USER_TYPE: 'USER_TYPE',

    SAVE_OPEN_TREE_VALUE: 'SAVE_OPEN_TREE_VALUE',

    //Add affiliates
    ADD_NEW_AFFILIATE_BEGIN: 'ADD_NEW_AFFILIATE_BEGIN',
    ADD_NEW_AFFILIATE_SUCCESS: 'ADD_NEW_AFFILIATE_SUCCESS',
    ADD_NEW_AFFILIATE_FAILURE: 'ADD_NEW_AFFILIATE_FAILURE',

    //Get affiliates
    GET_AFFILIATE_BEGIN: 'GET_AFFILIATE_BEGIN',
    GET_AFFILIATE_SUCCESS: 'GET_AFFILIATE_SUCCESS',
    GET_AFFILIATE_FAILURE: 'GET_AFFILIATE_FAILURE',

    //Get project id
    GET_PROJECT_ID_BEGIN: 'GET_PROJECT_ID_BEGIN',
    GET_PROJECT_ID_SUCCESS: 'GET_PROJECT_ID_SUCCESS',
    GET_PROJECT_ID_FAILURE: 'GET_PROJECT_ID_FAILURE',

    //Get user allowed affiliates
    GET_USER_ALLOWED_AFFILIATES_BEGIN: 'GET_USER_ALLOWED_AFFILIATES_BEGIN',
    GET_USER_ALLOWED_AFFILIATES_SUCCESS: 'GET_USER_ALLOWED_AFFILIATES_SUCCESS',
    GET_USER_ALLOWED_AFFILIATES_FAILURE: 'GET_USER_ALLOWED_AFFILIATES_FAILURE',

    //Get Design URL
    GET_DESIGN_BEGIN: 'GET_DESIGN_BEGIN',
    GET_DESIGN_SUCCESS: 'GET_DESIGN_SUCCESS',
    GET_DESIGN_FAILURE: 'GET_DESIGN_FAILURE',

    //Get affiliates Info
    GET_AFFILIATE_INFO_BEGIN: 'GET_AFFILIATE_INFO_BEGIN',
    GET_AFFILIATE_INFO_SUCCESS: 'GET_AFFILIATE_INFO_SUCCESS',
    GET_AFFILIATE_INFO_FAILURE: 'GET_AFFILIATE_INFO_FAILURE',

    //Delete affiliates
    CHANGE_STATUS_BEGIN: 'CHANGE_STATUS_BEGIN',
    CHANGE_STATUS_SUCCESS: 'CHANGE_STATUS_SUCCESS',
    CHANGE_STATUS_FAILURE: 'CHANGE_STATUS_FAILURE',

    //Get permissions
    GET_PERMISSIONS_BEGIN: 'GET_PERMISSIONS_BEGIN',
    GET_PERMISSIONS_KEEP_OLD_BEGIN: 'GET_PERMISSIONS_KEEP_OLD_BEGIN',
    GET_PERMISSIONS_SUCCESS: 'GET_PERMISSIONS_SUCCESS',
    GET_PERMISSIONS_FAILURE: 'GET_PERMISSIONS_FAILURE',

    //Update permissions
    UPDATE_PERMISSIONS_BEGIN: 'UPDATE_PERMISSIONS_BEGIN',
    UPDATE_PERMISSIONS_SUCCESS: 'UPDATE_PERMISSIONS_SUCCESS',
    UPDATE_PERMISSIONS_FAILURE: 'UPDATE_PERMISSIONS_FAILURE',

    //Get permissions
    GET_COMMISSIONS_BEGIN: 'GET_COMMISSIONS_BEGIN',
    GET_COMMISSIONS_SUCCESS: 'GET_COMMISSIONS_SUCCESS',
    GET_COMMISSIONS_FAILURE: 'GET_COMMISSIONS_FAILURE',

    UPDATE_COMMISSIONS_BEGIN: 'UPDATE_COMMISSIONS_BEGIN',
    UPDATE_COMMISSIONS_SUCCESS: 'UPDATE_COMMISSIONS_SUCCESS',
    UPDATE_COMMISSIONS_FAILURE: 'UPDATE_COMMISSIONS_FAILURE',

    // Reports
    GET_PAYMENT_REPORT_BEGIN: 'GET_PAYMENT_REPORT_BEGIN',
    GET_PAYMENT_REPORT_SUCCESS: 'GET_PAYMENT_REPORT_SUCCESS',
    GET_PAYMENT_REPORT_ERROR: 'GET_PAYMENT_REPORT_ERROR',

    GET_REPORT_FOR_AFFILIATE_BEGIN: 'GET_REPORT_FOR_AFFILIATE_BEGIN',
    GET_REPORT_FOR_AFFILIATE_SUCCESS: 'GET_REPORT_FOR_AFFILIATE_SUCCESS',
    GET_REPORT_FOR_AFFILIATE_ERROR: 'GET_REPORT_FOR_AFFILIATE_ERROR',

    GET_REPORT_OPERATION_TYPE_BEGIN: 'GET_REPORT_OPERATION_TYPE_BEGIN',
    GET_REPORT_OPERATION_TYPE_SUCCESS: 'GET_REPORT_OPERATION_TYPE_SUCCESS',
    GET_REPORT_OPERATION_TYPE_ERROR: 'GET_REPORT_OPERATION_TYPE_ERROR',

    GET_REPORT_PAYMENTS_BEGIN: 'GET_REPORT_PAYMENTS_BEGIN',
    GET_REPORT_PAYMENTS_SUCCESS: 'GET_REPORT_PAYMENTS_SUCCESS',
    GET_REPORT_PAYMENTS_ERROR: 'GET_REPORT_PAYMENTS_ERROR',

    // Domains
    CREATE_DOMAIN_BEGIN: 'CREATE_DOMAIN_BEGIN',
    CREATE_DOMAIN_SUCCESS: 'CREATE_DOMAIN_SUCCESS',
    CREATE_DOMAIN_FAILURE: 'CREATE_DOMAIN_FAILURE',

    SET_DOMAIN_STATUS_BEGIN: 'SET_DOMAIN_STATUS_BEGIN',
    SET_DOMAIN_STATUS_SUCCESS: 'SET_DOMAIN_STATUS_SUCCESS',
    SET_DOMAIN_STATUS_FAILURE: 'SET_DOMAIN_STATUS_FAILURE',

    GET_DOMAIN_AFFILIATE_BEGIN: 'GET_DOMAIN_AFFILIATE_BEGIN',
    GET_DOMAIN_AFFILIATE_SUCCESS: 'GET_DOMAIN_AFFILIATE_SUCCESS',
    GET_DOMAIN_AFFILIATE_FAILURE: 'GET_DOMAIN_AFFILIATE_FAILURE',

    GET_DOMAIN_SUBAFFILIATE_BEGIN: 'GET_DOMAIN_SUBAFFILIATE_BEGIN',
    GET_DOMAIN_SUBAFFILIATE_SUCCESS: 'GET_DOMAIN_SUBAFFILIATE_SUCCESS',
    GET_DOMAIN_SUBAFFILIATE_FAILURE: 'GET_DOMAIN_SUBAFFILIATE_FAILURE',

    DELETE_DOMAIN_BEGIN: 'DELETE_DOMAIN_BEGIN',
    DELETE_DOMAIN_SUCCESS: 'DELETE_DOMAIN_SUCCESS',
    DELETE_DOMAIN_ERROR: 'DELETE_DOMAIN_ERROR',

    //Users
    GET_ALL_USERS_BEGIN: 'GET_ALL_USERS_BEGIN',
    GET_ALL_USERS_SUCCESS: 'GET_ALL_USERS_SUCCESS',
    GET_ALL_USERS_FAILURE: 'GET_ALL_USERS_FAILURE',

    GET_USER_BEGIN: 'GET_USER_BEGIN',
    GET_USER_SUCCESS: 'GET_USER_SUCCESS',
    GET_USER_FAILURE: 'GET_USER_FAILURE',

    ADD_USER_BEGIN: 'ADD_USER_BEGIN',
    ADD_USER_SUCCESS: 'ADD_USER_SUCCESS',
    ADD_USER_FAILURE: 'ADD_USER_FAILURE',

    GET_USER_TYPES_BEGIN: 'GET_USER_TYPES_BEGIN',
    GET_USER_TYPES_SUCCESS: 'GET_USER_TYPES_SUCCESS',
    GET_USER_TYPES_FAILURE: 'GET_USER_TYPES_FAILURE',

    GET_USER_ALLOWED_PARTNERS_BEGIN: 'GET_USER_ALLOWED_PARTNERS_BEGIN',
    GET_USER_ALLOWED_PARTNERS_SUCCESS: 'GET_USER_ALLOWED_PARTNERS_SUCCESS',
    GET_USER_ALLOWED_PARTNERS_FAILURE: 'GET_USER_ALLOWED_PARTNERS_FAILURE',

    EDIT_USER_BEGIN: 'EDIT_USER_BEGIN',
    EDIT_USER_SUCCESS: 'EDIT_USER_SUCCESS',
    EDIT_USER_ERROR: 'EDIT_USER_ERROR',

    DELETE_USER_BEGIN: 'DELETE_USER_BEGIN',
    DELETE_USER_SUCCESS: 'DELETE_USER_SUCCESS',
    DELETE_USER_ERROR: 'DELETE_USER_ERROR',

    // Players
    GET_PLAYERS_BEGIN: 'GET_PLAYERS_BEGIN',
    GET_PLAYERS_SUCCESS: 'GET_PLAYERS_SUCCESS',
    GET_PLAYERS_FAILURE: 'GET_PLAYERS_FAILURE',

    TOPUP_PLAYER_BEGIN: 'TOPUP_PLAYER_BEGIN',
    TOPUP_PLAYER_SUCCESS: 'TOPUP_PLAYER_SUCCESS',
    TOPUP_PLAYER_FAILURE: 'TOPUP_PLAYER_FAILURE',
    GET_PLAYER_BALANCE_BEGIN: 'GET_PLAYER_BALANCE_BEGIN',
    GET_PLAYER_BALANCE_SUCCESS: 'GET_PLAYER_BALANCE_SUCCESS',
    GET_PLAYER_BALANCE_FAILURE: 'GET_PLAYER_BALANCE_FAILURE',

    // Sign Ups
    GET_SIGNUPS_BEGIN: 'GET_SIGNUPS_BEGIN',
    GET_SIGNUPS_SUCCESS: 'GET_SIGNUPS_SUCCESS',
    GET_SIGNUPS_ERROR: 'GET_SIGNUPS_ERROR',

    DELETE_SIGNUPS_BEGIN: 'DELETE_SIGNUPS_BEGIN',
    DELETE_SIGNUPS_SUCCESS: 'DELETE_SIGNUPS_SUCCESS',
    DELETE_SIGNUPS_ERROR: 'DELETE_SIGNUPS_ERROR',

    // Languages
    GET_LANGUAGES_BEGIN: 'GET_LANGUAGES_BEGIN',
    GET_LANGUAGES_SUCCESS: 'GET_LANGUAGES_SUCCESS',
    GET_LANGUAGES_FAILURE: 'GET_LANGUAGES_FAILURE',

    // Currencies
    GET_CURRENCIES_BEGIN: 'GET_CURRENCIES_BEGIN',
    GET_CURRENCIES_SUCCESS: 'GET_CURRENCIES_SUCCESS',
    GET_CURRENCIES_FAILURE: 'GET_CURRENCIES_FAILURE',

    // Withdraw
    GET_WITHDRAW_BEGIN: 'GET_WITHDRAW_BEGIN',
    GET_WITHDRAW_SUCCESS: 'GET_WITHDRAW_SUCCESS',
    GET_WITHDRAW_FAILURE: 'GET_WITHDRAW_FAILURE',

    GET_WITHDRAW_DETAILS_BEGIN: 'GET_WITHDRAW_DETAILS_BEGIN',
    GET_WITHDRAW_DETAILS_SUCCESS: 'GET_WITHDRAW_DETAILS_SUCCESS',
    GET_WITHDRAW_DETAILS_FAILURE: 'GET_WITHDRAW_DETAILS_FAILURE',

    UPDATE_WITHDRAW_BEGIN: 'UPDATE_WITHDRAW_BEGIN',
    UPDATE_WITHDRAW_SUCCESS: 'UPDATE_WITHDRAW_SUCCESS',
    UPDATE_WITHDRAW_FAILURE: 'UPDATE_WITHDRAW_FAILURE',

    GET_SUB_WITHDRAW_BEGIN: 'GET_SUB_WITHDRAW_BEGIN',
    GET_SUB_WITHDRAW_SUCCESS: 'GET_SUB_WITHDRAW_SUCCESS',
    GET_SUB_WITHDRAW_FAILURE: 'GET_SUB_WITHDRAW_FAILURE',

    CREATE_WITHDRAW_BEGIN: 'CREATE_WITHDRAW_BEGIN',
    CREATE_WITHDRAW_SUCCESS: 'CREATE_WITHDRAW_SUCCESS',
    CREATE_WITHDRAW_FAILURE: 'CREATE_WITHDRAW_FAILURE',

    CREATE_ADVANCE_WITHDRAW_BEGIN: 'CREATE_ADVANCE_WITHDRAW_BEGIN',
    CREATE_ADVANCE_WITHDRAW_SUCCESS: 'CREATE_ADVANCE_WITHDRAW_SUCCESS',
    CREATE_ADVANCE_WITHDRAW_FAILURE: 'CREATE_ADVANCE_WITHDRAW_FAILURE',

    // Get Withdraw Type
    GET_WITHDRAWAL_TYPES_SUCCESS: 'GET_WITHDRAWAL_TYPES_SUCCESS',
    //Get Withdraw Balance
    GET_WITHDRAWABLE_BALANCE_SUCCESS: 'GET_WITHDRAWABLE_BALANCE_SUCCESS',

    // Captcha Settings
    GET_PROJECT_CAPTCHA_PROVIDERS_ERROR: 'GET_PROJECS_CAPTCHA_PROVIDERS_ERROR',
    GET_PROJECT_CAPTCHA_PROVIDERS_SUCCESS: 'GET_PROJECT_CAPTCHA_PROVIDERS_SUCCESS',
    SET_PROJECTS_CAPTCHA_ERROR: 'SET_PROJECTS_CAPTCHA_ERROR',
    SET_PROJECTS_CAPTCHA_SUCCESS: 'SET_PROJECTS_CAPTCHA_SUCCESS',
    GET_ALL_CAPTCHA_PROVIDERS_ERROR: "GET_ALL_CAPTCHA_PROVIDERS_ERROR",
    GET_PROJECS_ALL_CAPTCHA_PROVIDERS_SUCCESS: "GET_PROJECS_ALL_CAPTCHA_PROVIDERS_SUCCESS",
    GET_CAPTCHA_BEGIN: 'GET_CAPTCHA_BEGIN',
    SET_CAPTCHA_BEGIN: 'SET_CAPTCHA_BEGIN',

    CHANGE_LANGUAGE_WAITING_STATE: 'CHANGE_LANGUAGE_WAITING_STATE',
};

export default ActionType;


// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js